var _Path, _G, _Rect, _G2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G, Circle, Rect, Defs, ClipPath } from "react-native-svg";
var SvgProductsInfoIcon = function SvgProductsInfoIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "mask0_3529_26422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 0H0v90h62.54c-4.302-3.577-7.04-8.969-7.04-15 0-10.77 8.73-19.5 19.5-19.5 6.031 0 11.423 2.738 15 7.04V0Zm0 87.46A19.614 19.614 0 0 1 87.46 90H90v-2.54Z",
    fill: "#F7931A"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#mask0_3529_26422)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 45,
    cy: 45,
    r: 42.5,
    stroke: "#4285F4",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 45,
    cy: 45,
    r: 30,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.487 56.82c-.522 0-.927.072-1.215.216a26.14 26.14 0 0 1-4.428 1.836c-1.512.468-3.33.702-5.454.702-4.608 0-8.226-1.422-10.854-4.266-2.412-2.628-3.618-6.102-3.618-10.422s1.206-7.794 3.618-10.422c1.224-1.332 2.745-2.376 4.563-3.132 1.818-.756 3.852-1.134 6.102-1.134 2.25 0 4.13.234 5.643.702a26.14 26.14 0 0 1 4.428 1.836c.288.144.693.216 1.215.216.522 0 .972-.207 1.35-.621.378-.414.567-.882.567-1.404 0-.522-.108-.954-.324-1.296-.216-.342-.837-.792-1.863-1.35s-2.502-1.161-4.428-1.809c-1.926-.648-4.221-.972-6.885-.972-5.508 0-10.008 1.728-13.5 5.184-3.6 3.528-5.4 8.262-5.4 14.202 0 5.94 1.8 10.674 5.4 14.202 1.692 1.692 3.69 2.979 5.994 3.861 2.304.882 4.797 1.323 7.479 1.323 2.682 0 4.986-.324 6.912-.972a32.771 32.771 0 0 0 5.427-2.376c.792-.396 1.188-1.08 1.188-2.052a2.06 2.06 0 0 0-.567-1.431c-.378-.414-.828-.621-1.35-.621Zm-7.153-21.795c-1.046-.352-2.273-.525-3.682-.525-2.946 0-5.386.937-7.277 2.809-1.949 1.91-2.923 4.47-2.923 7.634 0 3.163.974 5.724 2.925 7.637a9.204 9.204 0 0 0 3.254 2.095c1.24.474 2.577.71 4.008.71 1.417 0 2.649-.172 3.695-.524a17.14 17.14 0 0 0 2.837-1.243c.63-.314.981-.92.981-1.682 0-.46-.166-.877-.48-1.221a1.632 1.632 0 0 0-1.228-.555c-.368 0-.68.055-.943.187a12.38 12.38 0 0 1-2.1.872c-.679.21-1.514.318-2.506.318-2.104 0-3.712-.632-4.876-1.892-1.07-1.166-1.61-2.721-1.61-4.702 0-1.981.54-3.536 1.612-4.704.536-.584 1.206-1.043 2.017-1.38.814-.34 1.733-.51 2.763-.51 1.055 0 1.922.108 2.6.317.711.22 1.407.51 2.086.866.277.139.59.194.957.194.476 0 .9-.195 1.228-.555.313-.342.48-.756.48-1.208 0-.394-.088-.748-.278-1.048-.2-.316-.583-.594-1.207-.933-.557-.304-1.333-.62-2.333-.957Z",
    fill: "white"
  }))), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 60,
    y: 60,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#37CC33"
  })), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_3529_26422)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M74.999 79.666c-1.488 0-2.867-.22-4-.597m4 .597V83m0-3.334c1.487 0 2.866-.22 4-.597m3-2.736v3.334c0 1.132-1.187 2.133-3 2.735m3-6.069c0 1.133-1.187 2.134-3 2.736m3-2.736c0-.823-.627-1.576-1.665-2.158M68 76.333v3.334c0 1.132 1.186 2.133 3 2.735m-3-6.069c0 1.133 1.186 2.134 3 2.736m-3-2.736c0-.21.04-.414.118-.613M74.999 83c-1.488 0-2.867-.221-4-.598m4 .598c1.487 0 2.866-.221 4-.598m-8 0V79.07m8 0v3.333m-4.335-8.97c-1.436.384-2.826.528-4.018.457m4.018-.458.863 3.22m-.863-3.22c1.437-.385 2.712-.955 3.71-1.612m2.189-3.42c-.477-1.778-3.89-2.408-7.624-1.407-3.735 1-6.375 3.253-5.9 5.031M80.564 68.4l.863 3.22c.216.807-.211 1.713-1.092 2.555m.229-5.775c.293 1.094-.594 2.368-2.19 3.419m-11.333.204.863 3.22c.045.17.117.329.214.477m-1.077-3.697c.293 1.094 1.698 1.754 3.606 1.866m4.88 2.762c-1.436.385-2.825.529-4.017.458m4.018-.458c1.436-.385 2.711-.955 3.709-1.612m-7.728 2.07-.862-3.22m.862 3.22c-1.611-.095-2.865-.58-3.391-1.389m10.256-3.901.863 3.22m0 0a7.8 7.8 0 0 0 1.098-.864",
    stroke: "white",
    strokeWidth: 1.25
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_3529_26422"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(65 65)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgProductsInfoIcon;